export type AppStateDevicesStatus = {
  bcgStatuses: DevicesStatusMap;
  callibrationStatuses: DevicesStatusMap;
  firmwareStatuses: DevicesStatusMap;
  powerStatuses: DevicesStatusMap;
  wifiStatuses: DevicesStatusMap;
  sensorsStatuses: DevicesStatusMap;
  activityStatuses: DevicesStatusMap;
  bluetoothStatuses: DevicesStatusMap;
  postureStatuses: DevicesStatusMap;
  occupancyStatuses: DevicesStatusMap;
  onOffStatuses: DevicesStatusMap;
  userNearbyStatuses: DevicesStatusMap;
  userNearbySettingsStatuses: DevicesStatusMap;
  isLoading: boolean;
};

export type OccupancyStatus = {
  id: DeviceStatusesNames;
  value: BedStatusValue;
  dateTime: string;
  // isMoving: boolean;
  // movementLevel: ResidentMovRelaxLevel;
  // relaxLevel: ResidentMovRelaxLevel;
};

export type DevicesStatusMap = {
  [key: string]: DeviceStatus;
};

export type OnOffStatus = {
  dateTime: string;
  isOn: boolean;
  id: DeviceStatusesNames;
};
export type UserNearbyStatus = {
  id: DeviceStatusesNames;
  nearRoom: UserNearVitals[];
  nearBed: UserNearVitals[];
};

export type UserNearbySettings = {
  bedDistance: number;
  roomDistance: number;
  blockFallPrevantion: boolean;
};
export type UserNearbySettingsStatus = {
  id: DeviceStatusesNames;
  bedDistance: number;
  roomDistance: number;
  blockFallPrevantion: boolean;
};

export type setUserNearbyDeviceSettingsDTO = UserNearbySettings & {
  deviceIds: string[];
};
export type UserNearVitals = {
  id: string;
  alert: boolean;
  datetime: string;
};
export type WifiStatus = {
  datetime: string;
  ssid: string;
  rssiQuality: number;
  rssiDbm: number;
  id: DeviceStatusesNames;
};

export type BluetoothStatus = {
  bridgeId: string;
  datetime: string;
  rssiDbm: number;
  id: DeviceStatusesNames;
};

export type PowerStatus = {
  datetime: string;
  batteryLevel: number;
  batteryCharging: boolean;
  connected: boolean;
  id: DeviceStatusesNames;
  failure: boolean;
};

export type FirmwareStatus = {
  datetime: string;
  mac: string;
  iccId: string;
  wifi: string;
  hardware: string;
  bluetooth: string;
  id: DeviceStatusesNames;
};

export type CalibrationStatus = {
  datetime: string;
  varLevel1: number;
  varLevel2: number;
  strokeVolume: number;
  tempStrokeVolume: number;
  signalRange: number;
  gVal: number;
  id: DeviceStatusesNames;
};

export type BCGStatus = {
  datetime: string;
  id: DeviceStatusesNames;
  tm: number;
  ss: number;
  st: number;
  b2B_0: number;
  b2B_1: number;
  b2B_2: number;
  hr: number;
  sp: number;
  rr: number;
  sv: number;
  hrv: number;
  po?: number;
  re?: string;
};
export type ActivityStatus = {
  id: DeviceStatusesNames;
  isActive: boolean;
  status: WhyNotActive;
  datetime: string;
};
export enum WhyNotActive {
  NO_WIFI = "NoWiFi",
  NO_BATTERY = "NoPower",
  NO_BLUETOOTH = "NoBluetooth",
  UNPLUGGED_AND_NO_BATTERY = "UnpluggedAndNoBattery",
  NO_4G = "No4G",
}
export type SensorsStatus = {
  id: string;
  temperature: {
    value: number;
    datetime: string;
  };
  gas: {
    value: number;
    datetime: string;
  };
  pir: {
    value: number;
    datetime: string;
    isConnected?: boolean;
  };
};

export type DeviceStatusSocket = {
  deviceId: string;
  nodeId: number;
  type: DeviceStatusesNamesSocket;
  value: any;
  status?: any;
};
export enum PostureStatusValue {
  UNKNOWN = "UNKNOWN",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  STOMACH = "STOMACH",
  STAND = "STAND",
  BACK = "BACK",
  FALL = "FALL",
  SIT = "SIT",
  WALK = "WALK",
  UNATTACHED = "UNATTACHED",
}

export enum PostureStatusNumbers {
  UNKNOWN = 0,
  LEFT = 3,
  RIGHT = 4,
  STOMACH = 1,
  STAND = 5,
  BACK = 2,
  FALL = 6,
  SIT = 7,
  WALK = 8,
  UNATTACHED = 9,
}

export type PostureStatus = {
  id: DeviceStatusesNames;
  value: PostureStatusValue;
  datetime: string;
  previousDatetime?: string;
  outOfBody: boolean;
};

export type BioPatchStatus = {
  id: DeviceStatusesNames;
  BatteryLevel: number;
  BridgeID: string;
  BridgeTimeStamp: number;
  HR: number;
  Posture: number;
  RSSI: number;
  SpO2: number;
  Temperature: number;
  Time: string;
  OutOfBody?: boolean;
};

export type DeviceStatus =
  | WifiStatus
  | PowerStatus
  | FirmwareStatus
  | CalibrationStatus
  | BCGStatus
  | ActivityStatus
  | BluetoothStatus
  | SensorsStatus
  | PostureStatus
  | OccupancyStatus
  | BioPatchStatus
  | OnOffStatus
  | UserNearbyStatus
  | UserNearbySettingsStatus;

export enum DeviceStatusesNames {
  BCG = "bcg",
  CALIBRATION = "calibration",
  FIRMWARE = "firmware",
  POWER = "power",
  WIFI = "wifi",
  SENSORS = "sensors",
  ACTIVITY = "activity",
  BLUETOOTH = "bluetooth",
  OCCUPANCY = "occupancy",
  POSTURE = "posture",
  BIOPATCH_MESSAGE = "BioPatchMessage",
  ON_OFF = "onOff",
  USER_NEARBY = "userNearby",
  USER_NEARBY_SETTINGS = "userNearbySettings",
}

export enum DeviceStatusesNamesSocket {
  WIFI = "WiFiStatus",
  BCG = "BCGMessage",
  CALIBRATION = "calibration",
  FIRMWARE = "firmware",
  POWER_CONNECTED = "PowerConnected",
  SENSORS = "sensors",
  ACTIVITY = "Activity",
  BATTERY_LEVEL = "BatteryLevel",
  BATTERY_CHARGING_STATE = "BatteryChargingState",
  OCCUPANCY = "occupancy",
  BIOPATCH_MESSAGE = "BioPatchMessage",
  BATTERY_FAILURE = "BatteryFailure",
  POSTURE_CHANGED = "PostureChanged",
  OUT_OF_BODY_CHANGED = "OutOfBodyChanged",
  PIR_CONNECTION = "PirConnection",
  ANGLE_FAILURE = "AngleFailure",
  OnOff = "OnOff",
  UserNearby = "UserNearby",
  BluetoothStatus = "BluetoothStatus",
  UserNearbySettings = "UserNearbySettings",
}

export const EMPTY_POSTURE_STATUS: PostureStatus = {
  id: DeviceStatusesNames.POSTURE,
  value: PostureStatusValue.UNKNOWN,
  datetime: "",
  previousDatetime: "",
  outOfBody: false,
};

export const convertSocketToDeviceStatuses = (
  data: DeviceStatusSocket,
  deviceId = ""
): DeviceStatus => {
  try {
    const obj = { ...JSON.parse(data.value) };
    switch (data.type.toLowerCase()) {
      case DeviceStatusesNamesSocket.BATTERY_CHARGING_STATE.toLowerCase():
        return {
          id: DeviceStatusesNames.POWER,
          batteryCharging: obj.IsCharging,
          datetime: obj.Time,
        } as PowerStatus;
      case DeviceStatusesNamesSocket.BATTERY_LEVEL.toLowerCase():
        return {
          id: DeviceStatusesNames.POWER,
          batteryLevel: obj.Level,
          datetime: obj.Time,
        } as PowerStatus;
      case DeviceStatusesNamesSocket.POWER_CONNECTED.toLowerCase():
        return {
          id: DeviceStatusesNames.POWER,
          connected: obj.IsCharging,
          datetime: obj.Time,
        } as PowerStatus;
      case DeviceStatusesNamesSocket.WIFI.toLowerCase():
        return {
          id: DeviceStatusesNames.WIFI,
          rssiDbm: obj.RSSIDbm,
          rssiQuality: obj.RSSIQuality,
          ssid: obj.CurrentSSID,
          datetime: obj.Time,
        } as WifiStatus;
      case DeviceStatusesNamesSocket.SENSORS.toLowerCase():
        return {
          temperature: {
            value: data.value,
          },
          id: DeviceStatusesNames.SENSORS,
        } as SensorsStatus;
      case DeviceStatusesNamesSocket.PIR_CONNECTION.toLowerCase():
        return {
          pir: {
            isConnected: data.value === "true" ? true : false,
          },
          id: DeviceStatusesNames.SENSORS,
        } as SensorsStatus;
      case DeviceStatusesNamesSocket.ACTIVITY.toLowerCase(): {
        return {
          id: DeviceStatusesNames.ACTIVITY,
          isActive: Boolean(obj?.IsActive),
          datetime: obj?.DateTime,
          status: obj?.Status,
        } as ActivityStatus;
      }
      case DeviceStatusesNamesSocket.BCG.toLowerCase(): {
        return undefined;
        // if (
        //     obj?.posture_change !== null &&
        //     obj?.posture_change !== false &&
        //     obj?.posture_change !== undefined
        // ) {
        //     // console.log('olala posture!');
        // }
        // const ret = {
        //     datetime: obj?.Time,
        //     id: DeviceStatusesNames.BCG, //data.value?.ID,
        //     tm: obj?.TM,
        //     ss: obj?.SS,
        //     st: obj?.ST,
        //     b2B_0: obj?.B2B_0,
        //     b2B_1: obj?.B2B_1,
        //     b2B_2: obj?.B2B_2,
        //     hr: obj?.HR,
        //     rr: obj?.RR,
        //     sv: obj?.SV,
        //     hrv: obj?.HRV,
        // } as BCGStatus;
        // // console.log(JSON.stringify(ret));
        // return ret;
      }
      case DeviceStatusesNamesSocket.BIOPATCH_MESSAGE.toLowerCase(): {
        const ret = {
          Time: obj?.Time,
          id: DeviceStatusesNames.BIOPATCH_MESSAGE, //data.value?.ID,
          Temperature: obj?.Temperature,
          SpO2: obj?.SpO2,
          RSSI: obj?.RSSI,
          Posture: obj?.Posture,
          HR: obj?.HR,
          BridgeTimeStamp: obj?.BridgeTimeStamp,
          BridgeID: obj?.BridgeID,
          BatteryLevel: obj?.BatteryLevel,
          OutOfBody:
            obj?.OutOfBody !== null && obj?.OutOfBody !== undefined
              ? obj?.OutOfBody?.toString()?.toLowerCase() === "true"
                ? true
                : false
              : false,
        } as BioPatchStatus;
        // if (data.deviceId === 'VBPBO0000000119')
        //     console.log('BIOPATCH_MESSAGE ' + parsePostValue(ret.Posture) + ret.OutOfBody);
        // console.log(JSON.stringify(ret));
        return ret;
      }
      case DeviceStatusesNamesSocket.BATTERY_FAILURE.toLowerCase(): {
        if (obj?.Failure === null) return undefined;
        return {
          id: DeviceStatusesNames.POWER,
          failure: obj?.Failure,
          datetime: obj?.Time,
        } as PowerStatus;
      }
      case DeviceStatusesNamesSocket.POSTURE_CHANGED.toLowerCase(): {
        const objAnother = data as any;
        if (objAnother?.value !== null) {
          const occup: PostureStatus = {
            datetime: objAnother?.Time,
            id: DeviceStatusesNames.POSTURE,
            value: parsePostValue(parseInt(objAnother?.value)),
          } as PostureStatus;
          // if (data.deviceId === 'VBPBO0000000119') console.log('POSTURE_CHANGED ' + occup.value);
          return occup;
        } else return undefined;
      }
      case DeviceStatusesNamesSocket.OUT_OF_BODY_CHANGED.toLowerCase(): {
        const objAnother = data as any;
        if (objAnother?.value !== null) {
          const value =
            objAnother?.value?.toLowerCase() === "true" ? true : false;
          const occup: PostureStatus = {
            datetime: objAnother?.Time,
            id: DeviceStatusesNames.POSTURE,
            value: objAnother?.value
              ? PostureStatusValue.UNATTACHED
              : PostureStatusValue.UNKNOWN,
            outOfBody: value,
          } as PostureStatus;
          // if (data.deviceId === 'VBPBO0000000119') console.log('POSTURE_CHANGED ' + occup.value);
          return occup;
        } else return undefined;
      }
      case DeviceStatusesNamesSocket.ANGLE_FAILURE.toLowerCase(): {
        return undefined;
      }
      case DeviceStatusesNamesSocket.OnOff.toLowerCase(): {
        return {
          id: DeviceStatusesNames.ON_OFF,
          isOn: obj?.IsOn,
          dateTime: obj?.DateTime,
        } as OnOffStatus;
      }
      case DeviceStatusesNamesSocket.UserNearby.toLowerCase(): {
        if (obj?.nearRoom || obj?.nearBed) {
          const dataFull = JSON.parse(data.value);
          const nearRoom = dataFull?.nearRoom || [];
          const nearBed = dataFull?.nearBed || [];
          const nearRoomWithout = nearRoom.filter((room) => {
            return nearBed.findIndex((bed) => bed.id === room.id) === -1;
          });
          return {
            id: DeviceStatusesNames.USER_NEARBY,
            nearRoom: nearRoomWithout,
            nearBed,
          } as UserNearbyStatus;
        }
        return {
          id: DeviceStatusesNames.USER_NEARBY,
          nearBed: Object.values(obj),
        } as UserNearbyStatus;
      }
      case DeviceStatusesNamesSocket.UserNearbySettings.toLowerCase(): {
        return {
          id: DeviceStatusesNames.USER_NEARBY_SETTINGS,
          roomDistance: obj?.roomDistance,
          bedDistance: obj?.bedDistance,
          blockFallPrevantion: obj?.blockFallPrevantion,
        } as UserNearbySettingsStatus;
      }
      case DeviceStatusesNamesSocket.BluetoothStatus.toLowerCase(): {
        return {
          id: DeviceStatusesNames.BLUETOOTH,
          bridgeId: obj?.BridgeId,
          datetime: obj?.Datetime,
          rssiDbm: obj?.RssiDbm,
        } as BluetoothStatus;
      }
      default:
        return undefined;
    }
  } catch (e) {
    debugger;
  }
};

// export const EMPTY_WIFI_STATUS: WifiStatus = {
//     datetime: undefined,
//     ssid: undefined,
//     rssiQuality: undefined,
//     rssiDbm: undefined,
//     id: DeviceStatusesNames.WIFI,
// };

export const isVitalsCharging = (powerSt: PowerStatus): boolean => {
  return (
    powerSt.connected ||
    (powerSt?.batteryCharging && powerSt?.batteryLevel !== 100)
  );
};

export const parsePostValue = (numberPost: number): PostureStatusValue => {
  switch (numberPost) {
    case PostureStatusNumbers.STOMACH:
      return PostureStatusValue.STOMACH;
    case PostureStatusNumbers.BACK:
      return PostureStatusValue.BACK;
    case PostureStatusNumbers.LEFT:
      return PostureStatusValue.LEFT;
    case PostureStatusNumbers.RIGHT:
      return PostureStatusValue.RIGHT;
    case PostureStatusNumbers.STAND:
      return PostureStatusValue.STAND;
    case PostureStatusNumbers.FALL:
      return PostureStatusValue.FALL;
    case PostureStatusNumbers.SIT:
      return PostureStatusValue.SIT;
    case PostureStatusNumbers.WALK:
      return PostureStatusValue.WALK;
    case PostureStatusNumbers.UNATTACHED:
      return PostureStatusValue.UNATTACHED;
  }
  return PostureStatusValue.UNKNOWN;
};

export const parsePosture = (
  numberPost: number,
  datetime: string,
  outOfBody?: boolean
): PostureStatus => {
  const value = parsePostValue(numberPost);
  return {
    value,
    datetime,
    id: DeviceStatusesNames.POSTURE,
    previousDatetime: null,
    outOfBody: outOfBody === undefined ? false : outOfBody,
  };
};

export enum BedStatusValue {
  IN_BED = "inBed",
  OUT_OF_BED = "outOfBed",
  INIT = "init",
}
export type BedStatusSocket = {
  status: BedStatusValue;
  residentId: string;
};

export type PostureStatusSocket = {
  value: any;
  residentId: string;
};
export type ResidentDevicesStatusesSocket = {
  bedStatus: BedStatusSocket;
  postureStatus: PostureStatusSocket;
};

export const VITALS_LOW_RSSI = -70;
export const BIOPATCH_NO_RSSI = -95;

export const convertWatchStatus = (data: DeviceStatusSocket): DeviceStatus => {
  const obj = JSON.parse(data.status);
  if (obj?.hasOwnProperty("Online"))
    return {
      id: DeviceStatusesNames.ACTIVITY,
      isActive: Boolean(obj?.Online),
      datetime: data["createdAt"],
      status: obj?.Status,
    } as ActivityStatus;
  else if (
    obj?.hasOwnProperty("PowerLevel") ||
    obj?.hasOwnProperty("BatteryLevel")
  )
    return {
      id: DeviceStatusesNames.POWER,
      datetime: data["createdAt"],
      batteryLevel: obj?.PowerLevel ? obj?.PowerLevel : obj?.BatteryLevel,
      batteryCharging: undefined,
      connected: undefined,
      failure: undefined,
    } as PowerStatus;
  return undefined;
};
